import { Guide } from '@repo/types';
import { Typography } from 'components';
import styles from './AdditionalResources.module.css';
import ResourceCard from './ResourceCard';

interface AdditionalResourcesProps {
  guides?: Guide[];
}

export default function AdditionalResources({
  guides,
}: AdditionalResourcesProps) {
  if (!guides || guides.length === 0) return null;

  return (
    <div className={styles.container}>
      <Typography variant='heading-m'>Additional resources</Typography>
      <div className={styles.guidesContainer}>
        {guides.map(guide => (
          <ResourceCard key={guide.id} guide={guide} />
        ))}
      </div>
    </div>
  );
}
